<ng-container *transloco="let t; read: 'ime.parameters.cost-price-components'">
  <app-toolbar *ngIf="filter$ | async as filter">
    <app-breadcrumbs>
    </app-breadcrumbs>
    <app-page-search class="me-auto" [(searchString)]="filter.Global" (searchStringChange)="filter$.next(filter)"></app-page-search>
    <app-toolbar-list-buttons *ngIf="PRIVILEGES.EditCommonData | userHasPrivilege" [showAdd]="false">
      <label class="btn btn-outline-primary my-0 me-1" style="cursor: pointer;">
        {{t('Import')}}
        <input type="file" style="display: none" (change)="import($event)">
      </label>
      <button type="button" class="btn btn-outline-primary btn-sm d-print-none" (click)="export()">
        {{t('Export')}}
      </button>
    </app-toolbar-list-buttons>
  </app-toolbar>
  <p-table styleClass="p-datatable-sm p-datatable-striped"
           dataKey="Id"
           sortField="Code"
           [value]="costComponents$ | async"
           [globalFilterFields]="['Item', 'Resource', 'Component', 'Price']"
           [paginator]="true"
           [rows]="50"
           [rowsPerPageOptions]="rowsPerPageOptions"
           [showCurrentPageReport]="true"
           currentPageReportTemplate="{first} to {last} of {totalRecords}">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="Item" *ngIf="mode === 'Item'">
          {{t('Item')}}
          <p-sortIcon field="Item"></p-sortIcon>
        </th>
        <th pSortableColumn="Resource" *ngIf="mode === 'Resource'">
          {{t('Resource')}}
          <p-sortIcon field="Resource"></p-sortIcon>
        </th>
        <th pSortableColumn="Component">
          {{t('Component')}}
          <p-sortIcon field="Component"></p-sortIcon>
        </th>
        <th>{{t('Expression')}}</th>
        <th pSortableColumn="Price">
          {{t('Price')}}
          <p-sortIcon field="Price"></p-sortIcon>
        </th>
        <th pSortableColumn="FromDate">
          {{t('From')}}
          <p-sortIcon field="FromDate"></p-sortIcon>
        </th>
        <th pSortableColumn="ToDate">
          {{t('To')}}
          <p-sortIcon field="ToDate"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td>
          <a *ngIf="mode === 'Item'" [routerLink]="['/manufacturing/item/edit/', row.ItemId]" class="text-break">{{row.Item}}</a>
          <a *ngIf="mode === 'Resource'" [routerLink]="['/manufacturing/resource/edit/', row.ResourceId]" class="text-break">{{row.Resource}}</a>
        </td>
        <td>{{row.Component}}</td>
        <td>{{row.PriceExpression?.Formula}}</td>
        <td>{{row.Price}}</td>
        <td>{{row.FromDate | date: 'shortDate'}}</td>
        <td>{{row.ToDate | date: 'shortDate'}}</td>
      </tr>
    </ng-template>
  </p-table>
</ng-container>
